import React from 'react';

interface CustomCheckboxProps {
  checked: boolean;
  indeterminate?: boolean;
  onClick?: () => void;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({ checked, indeterminate = false, onClick }) => {
  const showIcon = checked || indeterminate;
  
  return (
    <div
      style={{
        cursor: 'pointer',
        width: '16px',
        height: '16px',
        minWidth: '16px',
        minHeight: '16px',
        borderRadius: '4px',
        opacity: 1,
        border: showIcon ? 'none' : '1px solid #ccc',
        backgroundColor: showIcon ? '#0C58DB' : 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={onClick}
    >
      {indeterminate ? (
        <svg width="9" height="2" viewBox="0 0 9 2" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L7.375 1" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      ) : checked ? (
        <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 3.66667L3.01754 5.66667L7 1" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      ) : null}
    </div>
  );
};

export default CustomCheckbox;